<div class="row">
  <nb-card>
    <nb-card-body>Hello from ngx-admin sandbox project.</nb-card-body>
  </nb-card>
</div>
